import * as React from 'react';

type ListKeyboardShortcutsConfig = {
  searchContainerSelector: string;
  onCreateNew: () => void;
  createModifier?: 'meta' | 'alt';
};

export function useListKeyboardShortcuts({
  searchContainerSelector,
  onCreateNew,
  createModifier = 'meta',
}: ListKeyboardShortcutsConfig) {
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === '1') {
        e.preventDefault();
        const searchInput = document.querySelector<HTMLInputElement>(
          `${searchContainerSelector} .\\@SearchField input`,
        );
        searchInput?.focus();
      }

      const isCreateModifierActive =
        createModifier === 'alt' ? e.altKey : e.metaKey || e.ctrlKey;

      if (isCreateModifierActive && (e.key === 't' || e.code === 'KeyT')) {
        e.preventDefault();
        onCreateNew();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [searchContainerSelector, onCreateNew, createModifier]);
}
